module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-right-7ba0855c1e7348d6b8f2ada622c260ab.svg";